(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/use-check-params/assets/javascripts/use-check-params.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/use-check-params/assets/javascripts/use-check-params.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect;
const aliasDialog = svs.bingo_react.components.common.dialog.aliasDialog;
const canPlayOnVertical = svs.accountservices.player_exclusions.canPlayOnVertical;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useLocation = _ReactRouterDOM.useLocation;
const useCheckParams = () => {
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    const checkParams = async () => {
      const params = new URLSearchParams(location.search);
      const missingAlias = Boolean(params.get('missingAlias'));
      const paused = Boolean(params.get('paused'));
      if (paused) {
        params.delete('paused');
        const qs = params.size > 0 ? "?".concat(params) : '';
        history.replace("".concat(location.pathname).concat(qs));
        await canPlayOnVertical('bingo');
      }
      if (missingAlias) {
        params.delete('missingAlias');
        const qs = params.size > 0 ? "?".concat(params) : '';
        history.replace("".concat(location.pathname).concat(qs));
        aliasDialog.open();
      }
    };
    const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
    if (isLoggedIn) {
      checkParams();
    }
  }, []); 
};
setGlobal('svs.bingo_react.components.useCheckParams', useCheckParams);

 })(window);